import type { Store, UnknownAction } from '@reduxjs/toolkit';

import { globalRequestComplete, globalRequestStart } from 'store/slices/global-status';

/** Avoids circular imports: `axios` must not import `store` directly (store → slices → fetcher → axios). */
let storeRef: Store | null = null;

export function registerGlobalStatusStore(store: Store) {
  storeRef = store;
}

function dispatchSafe(action: UnknownAction) {
  storeRef?.dispatch(action);
}

export function dispatchGlobalRequestStart() {
  dispatchSafe(globalRequestStart());
}

export function dispatchGlobalRequestSuccess() {
  dispatchSafe(globalRequestComplete({ success: true }));
}

export function dispatchGlobalRequestFailure() {
  dispatchSafe(globalRequestComplete({ success: false }));
}
